// Fragment "site (lot J)" — rempli par son lot de retrofit ; fusionné dans ./index.js.
// Convention : clés plates pointées, valeurs dans les 3 langues, jamais vides.
export default {
  fr: {
    "registry.t1_classic.tagline": "Chaleureux, magazine, naturopathie",
    "registry.t2_minimal.tagline": "Suisse, épuré, esthétique & soins",
    "registry.t3_warm_organic.tagline": "Terreux, fluide, coaching holistique",
    "registry.t4_bold_modern.tagline": "Brutaliste, néon, coaching sportif",
    "registry.t5_clinical.tagline": "Confiance, structuré, clinique",
    "registry.t6_luxe.tagline": "Cinématique, or, spas haut de gamme",
    "shared.nav.openMenu": "Ouvrir le menu",
    "shared.nav.closeMenu": "Fermer le menu",
    "shared.nav.more": "Plus",
    "clinical.badges.certified": "Certifié",
    "clinical.badges.byAppointment": "Sur rendez-vous",
    "clinical.badges.provenApproach": "Approche prouvée",
    "shared.brand.fallback": "Studio",
  },
  en: {
    "registry.t1_classic.tagline": "Warm, magazine-style, naturopathy",
    "registry.t2_minimal.tagline": "Swiss, clean, aesthetics & care",
    "registry.t3_warm_organic.tagline": "Earthy, fluid, holistic coaching",
    "registry.t4_bold_modern.tagline": "Brutalist, neon, sports coaching",
    "registry.t5_clinical.tagline": "Trustworthy, structured, clinical",
    "registry.t6_luxe.tagline": "Cinematic, gold, high-end spas",
    "shared.nav.openMenu": "Open menu",
    "shared.nav.closeMenu": "Close menu",
    "shared.nav.more": "More",
    "clinical.badges.certified": "Certified",
    "clinical.badges.byAppointment": "By appointment",
    "clinical.badges.provenApproach": "Proven approach",
    "shared.brand.fallback": "Studio",
  },
  es: {
    "registry.t1_classic.tagline": "Cálido, estilo revista, naturopatía",
    "registry.t2_minimal.tagline": "Suizo, depurado, estética y cuidados",
    "registry.t3_warm_organic.tagline": "Terroso, fluido, coaching holístico",
    "registry.t4_bold_modern.tagline": "Brutalista, neón, coaching deportivo",
    "registry.t5_clinical.tagline": "Confianza, estructurado, clínico",
    "registry.t6_luxe.tagline": "Cinemático, dorado, spas de alta gama",
    "shared.nav.openMenu": "Abrir el menú",
    "shared.nav.closeMenu": "Cerrar el menú",
    "shared.nav.more": "Más",
    "clinical.badges.certified": "Certificado",
    "clinical.badges.byAppointment": "Con cita previa",
    "clinical.badges.provenApproach": "Enfoque comprobado",
    "shared.brand.fallback": "Estudio",
  },
};
